import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { useGame } from '../context/GameContext';
import { ReactComponent as CoinNumber } from './coin.svg';
import { ReactComponent as CoinToss } from './cointoss.svg';

function RngCoin(props: any) {
    const [icon, setIcon] = useState('CoinToss');
    const { reset } = useGame();

    useEffect(() => {
        if(reset) {
            setIcon('CoinToss');
        }
    }, [reset]);

    let generate = async () => {
        for (let i = 0; i < 20; i++) {
            let rng = Math.floor(Math.random() * 2);
            switch (rng) {
                case 0:
                    setIcon('CoinNumber');
                    break;
                case 1:
                    setIcon('CoinHeads');
                    break;
            }
            
            await new Promise(r => setTimeout(r,150));
        }
    }

    switch(icon) {
        default:
        case 'CoinToss':
            return(<CoinToss className="svg-inline--fa SVG-icon App-icon" onClick={ generate }/>);

        case 'CoinNumber':
            return(<CoinNumber className="svg-inline--fa SVG-icon App-icon" onClick={ generate }/>);
        
        case 'CoinHeads':
            return(<FontAwesomeIcon className="App-icon" icon={ faUserCircle } onClick={ generate }/>);
    }
}

export default RngCoin;
